module.exports = __webpack_public_path__ + "static/img/25.108dc6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/25.png
// module id = a1Tu
// module chunks = 6